import { render, staticRenderFns } from "./who-are-you-saving-for.vue?vue&type=template&id=4b6673e2&lang=pug&"
import script from "./who-are-you-saving-for.vue?vue&type=script&lang=js&"
export * from "./who-are-you-saving-for.vue?vue&type=script&lang=js&"
import style0 from "./who-are-you-saving-for.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports